// @ts-nocheck
// material-ui
import { List, Typography } from '@mui/material';

// project import
import NavItem from './NavItem';
import menuItems from 'menu-items';
import useMenu from 'contexts/MenuContext';

// ==============================|| NAVIGATION ||============================== //

// front-end's Navigation + NavGroup (vertical branch): one titled List per menu group.
const Navigation = () => {
  const { drawerOpen } = useMenu();

  return (
    <div style={{ paddingTop: 6, paddingLeft: drawerOpen ? 0 : 4, paddingRight: drawerOpen ? 0 : 4 }}>
      {menuItems.items.map((group) => (
        <List
          key={group.id}
          subheader={
            group.title &&
            drawerOpen && (
              <div style={{ paddingLeft: 8, paddingRight: 8, marginBottom: 12, marginTop: 8 }}>
                <Typography variant="body1" sx={{ color: 'text.primary', fontSize: '0.88rem', fontWeight: 900, lineHeight: 1.3 }}>
                  {group.title}
                </Typography>
                {group.caption && (
                  <Typography variant="caption" color="secondary">
                    {group.caption}
                  </Typography>
                )}
              </div>
            )
          }
          sx={{ mt: drawerOpen && group.title ? 0.375 : 0, py: 0, zIndex: 0 }}
        >
          {group.children?.map((item) => <NavItem key={item.id} item={item} level={1} />)}
        </List>
      ))}
    </div>
  );
};

export default Navigation;
